var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"case"}},[_c('section',[_c('casebanner')],1),_c('section',[_c('caseprocess1')],1),_c('section',{staticClass:"casetjhflaw w_100"},[_c('casetjhfbdls')],1),_c('section',[_c('casezxlbhf')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }